<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12 col-sm-12 mb-3">
        <div class="card p-4">
          <div class="media">
            <div class="avatar-sm mr-3">
              <span
                class="
                  avatar-title
                  rounded-circle
                  bg-light
                  text-primary
                  border-primary
                  font-size-22
                "
              >
                <i class="bx bx-world bx-md"></i>
              </span>
            </div>
            <div class="media-body">
              <div class="row">
                <div class="col-sm-6">
                  <h5 class="mt-3">{{ $t("news.news") }}</h5>
                </div>
                <div class="col-sm-6 text-right">
                  <router-link
                    to="/news/news-target"
                    class="btn btn-success btn-sm mt-2"
                  >
                    {{ $t("news.list-news-target") }}
                    <i class="mdi mdi-arrow-right"></i>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-5 mb-4">
            <div class="col-sm-12">
              <div class="input-group text-right">
                <input
                  id="search"
                  type="text"
                  class="form-control"
                  v-model="searchKey"
                  placeholder="Search keyword..."
                  aria-describedby="search"
                  @keyup.enter="searchnews"
                />
                <div class="input-group-prepend">
                  <button
                    id="search"
                    class="input-group-text bg-primary text-white"
                    @click="searchnews"
                  >
                    <i class="bx bx-search-alt search-icon"></i>
                  </button>
                </div>
              </div>
              <div class="pt-2" v-if="target_data">
                <b>Target Profile : {{target_data.title}}</b>
              </div>
            </div>
          </div>
          <div v-if="loading" class="row mt-4 mb-4 mx-auto">
            <div class="text-center">
              <div
                class="spinner-border text-secondary"
                role="status"
                v-if="loading"
              >
                <span class="sr-only"
                  ><p>{{ $t("news.news-info") }}</p></span
                >
              </div>
              <p>
                {{ $t("news.please-wait") }}
              </p>
            </div>
          </div>
          <div
            v-if="error !== '' && !loading"
            class="row mt-5 mb-5 pb-4 mx-auto"
          >
            <div class="text-center">
              <span class="text-secondary">{{ error }}</span>
            </div>
          </div>
          <div class="col-sm-12" v-if="tableData[0] && !loading">
            <div class="row mt-4 mb-2">
              <div class="col-sm-12 col-md-6">
                <div class="d-flex">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      {{ $t("news.show") }}&nbsp;&nbsp;
                      <b-form-select
                        v-model="perPage"
                        size="md"
                        :options="pageOptions"
                        class="mx-1"
                      ></b-form-select>
                    </label>
                  </div>
                  <b-button
                    v-if="!target_data"
                    v-b-modal.modal-add-to-project
                    size="sm"
                    variant="primary"
                    class="btn"
                    style="height: 3%"
                    :disabled="selected.length == 0"
                  >
                    <i class="fas fa-user-plus py-2 m-0"></i>
                    {{ $t("news.add-to-target") }}
                  </b-button>
                   <b-button
                    v-else
                    @click="saveNews(target_data.id)"
                    size="sm"
                    variant="primary"
                    class="btn"
                    style="height: 3%"
                    :disabled="selected.length == 0"
                  >
                    <i class="fas fa-user-plus py-2 m-0"></i>
                    {{ $t("news.add-to-target") }}
                  </b-button>
                  <!-- modal add to project -->


                  <b-modal
                    size="lg"
                    hide-footer
                    :id="'modal-add-to-project'"
                    centered
                    :title="'Add to project'"
                    title-class="font-18"
                  >
                    <div class="row">
                      <div class="col-12">
                        <div class="card">
                          <div class="card-body">
                            <div class="row mt-1">
                              <!-- Search -->
                              <div class="col-6">
                                <h6 class="">Keyword : {{ searchKey }}</h6>
                              </div>
                              <div class="col-6">
                                <div
                                  id="tickets-table_filter"
                                  class="dataTables_filter text-md-right"
                                >
                                  <label
                                    class="d-inline-flex align-items-center"
                                  >
                                    {{ $t("news.search") }}:
                                    <b-form-input
                                      v-model="target.filter"
                                      type="search"
                                      :placeholder="$t('news.searchh')"
                                      class="form-control form-control-sm ml-2"
                                    ></b-form-input>
                                  </label>
                                </div>
                              </div>
                              <!-- End search -->
                            </div>
                            <!-- Table -->
                            <div class="table-responsive mb-0">
                              <b-table
                                :items="target.tableData"
                                :fields="target.fields"
                                bordered
                                responsive="sm"
                                :per-page="target.perPage"
                                :current-page="target.currentPage"
                                :sort-by.sync="target.sortBy"
                                :sort-desc.sync="target.sortDesc"
                                :filter="target.filter"
                                :filter-included-fields="target.filterOn"
                                @filtered="onFilteredTarget"
                                show-empty
                              >
                                <template #empty>
                                  <h6
                                    class="text-center"
                                    v-if="!loading.target"
                                  >
                                    {{ $t("table.empty-text") }}
                                  </h6>
                                  <h6 class="text-center" v-if="loading.target">
                                    <i class="bx bx-loader bx-spin bx-md"></i>
                                  </h6>
                                </template>
                                <template #cell(target)="row">
                                  <div class="col-sm-12">
                                    <div class="media">
                                      <img
                                        :src="
                                          url_image + row.item.image_project
                                        "
                                        class="mr-3 rounded-circle avatar-sm"
                                        alt="user-pic"
                                      />
                                      <div class="media-body">
                                        <b> {{ row.item.title }}</b> <br />
                                        <p class="text-secondary">
                                          {{ $t("all.updated") }} :
                                          {{ formatDate(row.item.updated_at) }}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </template>
                                <template #cell(description)="row">
                                  <span>
                                    {{
                                      row.item.description.substring(0, 100)
                                    }}...
                                  </span>
                                </template>
                                <template #cell(actions)="row">
                                  <b-button
                                    class="mr-2 btn-sm"
                                    variant="primary"
                                    @click="saveNews(row.item.id_target)"
                                  >
                                    <span class="d-flex align-items-center">
                                      <i class="bx bx-plus"></i>
                                      {{ $t("news.add") }}
                                    </span>
                                  </b-button>
                                </template>
                              </b-table>
                            </div>
                            <div class="row">
                              <div class="col">
                                <div
                                  class="
                                    dataTables_paginate
                                    paging_simple_numbers
                                    float-right
                                  "
                                >
                                  <ul
                                    class="pagination pagination-rounded mb-0"
                                  >
                                    <!-- pagination -->
                                    <b-pagination
                                      v-model="target.currentPage"
                                      :total-rows="rows_target"
                                      :per-page="target.perPage"
                                    ></b-pagination>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-modal>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-right"
                >
                  <label class="d-inline-flex align-items-center">
                    {{ $t("news.search") }}:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      :placeholder="$t('news.searchh')"
                      class="form-control form-control ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive mb-0">
              <b-table
                :items="tableData"
                :fields="fields"
                striped
                bordered
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
              >
                <template #head(bulk) width="4%">
                  <!-- <b-form-checkbox class="text-center mt-0" v-model="selectedAll"/> -->
                  <b-form-checkbox
                    v-model="selectAll"
                    @change="select"
                    class="text-center mt-0"
                  >
                  </b-form-checkbox>
                </template>
                <template #cell(bulk)="row" width="4%">
                  <b-form-checkbox
                    class="text-center mt-0"
                    v-model="selected"
                    :value="row.item"
                  />
                </template>
                <template #cell(published)="row">
                  <div class="col-sm-12">
                    <div class="media">
                      <div class="media-body">
                        <b> {{ row.item.source }}</b> <br />
                        <small>
                          <!-- <p class="text-secondary">Author : {{row.item.author}} </p>  -->
                          <p class="text-secondary">
                            <span
                              >{{ $t("news.author") }}: {{ row.item.author }}
                            </span>
                            <br />
                            <span
                              >{{ $t("news.published_at") }}:
                              {{ row.item.published_at }}
                            </span>
                          </p>
                        </small>
                      </div>
                    </div>
                  </div>
                </template>
                <template #cell(image)="row">
                  <div class="col-sm-12">
                    <img
                      :src="row.item.image"
                      class="img-fluid"
                      alt="news-pict"
                    />
                  </div>
                </template>
                <template #cell(title)="row">
                  <div>
                    <a
                      :href="row.item.url"
                      target="_blank"
                      class="text-primary"
                    >
                      {{ row.item.title }}
                      <span v-if="row.item.is_hoax == 1"
                        ><b-button variant="outline-primary" size="sm"
                          >Truth</b-button
                        ></span
                      >
                      <span v-if="row.item.is_hoax == 2"
                        ><b-button variant="outline-danger" size="sm"
                          >Hoax</b-button
                        ></span
                      >
                      <span v-if="row.item.is_hoax == 3"
                        ><b-button variant="outline-success" size="sm"
                          >Unknown</b-button
                        ></span
                      ></a
                    >
                  </div>
                </template>
                <template #cell(content)="row">
                  <div class="col-sm-12">
                    <span>{{ row.item.content.substring(0, 200) }}..</span>
                  </div>
                </template>
                <template #cell(actions)="row">
                  <div
                    class="col-md-12 text-center"
                    v-if="row.item.is_hoax == 0"
                  >
                    <b-button variant="primary" @click="cekHoaxs(row.item)"
                      ><b-spinner
                        v-if="loading_hoax && loading_hoax_url == row.item.url"
                        label="Loading ..."
                        small
                        class="px-1"
                      ></b-spinner
                      ><span v-else> Cek Hoax </span>
                    </b-button>
                  </div>
                  <div class="col-md-12 text-center" v-else>-</div>
                </template>
              </b-table>

              <div v-if="loadingInfo" class="mt-4 mx-auto p-5">
                <div class="text-center">
                  <div
                    class="spinner-border text-secondary"
                    role="status"
                    v-if="loadingInfo"
                  >
                    <span class="sr-only"
                      ><p>{{ $t("website.website-info") }}</p></span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="row" v-if="rows > 10">
              <div class="col-sm-12 test-right">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div
            class="col-sm-12 text-center"
            v-if="!tableData[0] && !loading && search && error == ''"
          >
            <p class="text-secondary p-5">{{ $t("overview.table.all.dnf") }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-if="!loading && !tableData[0]">
      <div class="col-lg-12 col-sm-12 mb-3">
        <div class="card p-4">
          <div class="row">
            <div class="col-sm-6">
              <h5 class="mt-3">
                <i class="bx bx-news mr-2 mb-1 text-primary"></i>Last News Hoax
              </h5>
            </div>
            <div class="col-sm-6 text-right">
              <!-- <router-link to="/news/news-target" class="btn btn-success btn-sm mt-2">
                                {{ $t('news.refresh') }}
                                <i class="bx bx-refresh"></i>
                            </router-link> -->
            </div>
          </div>
          <div v-if="loading" class="row mt-4 mb-4 mx-auto">
            <div class="text-center">
              <div
                class="spinner-border text-secondary"
                role="status"
                v-if="loading"
              >
                <span class="sr-only"
                  ><p>{{ $t("news.news-info") }}</p></span
                >
              </div>
              <p>
                {{ $t("news.please-wait") }}
              </p>
            </div>
          </div>
          <div
            v-if="error !== '' && !loading"
            class="row mt-5 mb-5 pb-4 mx-auto"
          >
            <div class="text-center">
              <span class="text-secondary">{{ error }}</span>
            </div>
          </div>
          <div
            class="col-sm-12"
            v-if="!tableData[0] && !loading && anti_hoax[0]"
          >
            <div class="row p-3">
              <div
                class="col-4 col-xs-6 mb-3"
                v-for="(hoax, index) in anti_hoax"
                :key="index"
              >
                <div class="card h-100 mb-4 border p-3">
                  <div class="position-relative">
                    <img :src="hoax.picture1" class="w-100 image mb-1" />
                    <div class="badge badge-success blog-badge font-size-11">
                      {{ hoax.classification }}
                    </div>
                  </div>

                  <div class="mt-4 text-muted">
                    <p class="mb-2">
                      <i class="bx bx-calendar mr-1"></i> {{ hoax.tanggal }}
                    </p>
                    <h5 class="mb-3">{{ hoax.title }}</h5>
                    <span v-if="hoax.conclusion"
                      ><b>Conclusion : </b> {{ hoax.conclusion.substring(0,200) }}.. <br
                    /></span>
                    <span v-if="hoax.source_issue"
                      ><b>Source Issue : </b> {{ hoax.source_issue }} <br
                    /></span>
                    <!-- <span v-if="hoax.references"
                      ><b>References :</b>
                      <a :href="hoax.references" target="_blank">{{
                        hoax.references
                      }}</a>
                      <br
                    /></span> -->
                    <span v-if="hoax.source_link"
                      ><b>Source Link : </b>
                      <a :href="hoax.source_link" target="_blank">{{
                        hoax.source_link
                      }}</a
                      ><br
                    /></span>
                    <span v-if="hoax.tags"
                      ><b>Tags :</b> {{ hoax.tags }}<br
                    /></span>
                    <button
                      class="btn-sm btn-primary px-3 mt-2 rounded"
                      @click="showFact(hoax.fact, hoax.conclusion, hoax.references)"
                      v-if="hoax.fact"
                    >
                      Detail
                    </button>
                    <!-- <b-button v-b-modal.modal-standard variant="primary">Standard modal</b-button> -->
                    <div></div>
                  </div>
                </div>
              </div>
              <b-modal
                ref="ref-modal-edit"
                id="modal-show-fact"
                size="xl"
                centered
                title="Cek Detail Fact"
                title-class="font-17"
                :cancel-hide="true"
              >
                <div class="row">
                   <div class="col-md-12">
                    <b>References</b>
                    <p class="text-justify">{{ show_references }}</p>
                  </div>
                  <div class="col-md-12"> 
                  <hr>
                    <b>Conclusion </b>
                    <p class="text-justify">{{ show_conclusion }}</p>
                  </div>
                  <div class="col-md-12">
                  <hr>
                    <b>Fakta</b>
                    <p class="text-justify">{{ show_fact }}</p>
                  </div>
                </div>
              </b-modal>
            </div>
          </div>
          <div
            class="col-sm-12 text-center"
            v-if="!anti_hoax[0] && !loading && search && error == ''"
          >
            <p class="text-secondary p-5">{{ $t("overview.table.all.dnf") }}</p>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Vue from "vue";
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import moment from "moment";
import PhoneService from "@/helpers/phone.service.js";
import WebsiteService from "@/helpers/website.service.js";
import NewsService from "@/helpers/news.service.js";
import SocmedService from "@/helpers/socmed.service.js";
import TargetService from "@/helpers/target-profile.service";
import Swal from "sweetalert2";
import { tableData } from "../../personal/dataAdvancedtable";

export default {
  page: {
    title: "Tools Website",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      target_data: "",
      id_target: this.$route.query.target,
      url_image:process.env.VUE_APP_BASE_API_URL + "target/image-project?name=",
      show_fact: "",
      show_conclusion:"",
      show_fact: "",
      show_references:"",
      anti_hoax: [],
      loading_hoax: false,
      loading_hoax_url: "",
      loading: false,
      loadingInfo: false,
      loadingsubdomain: false,
      error: "",
      search: false,
      searchKey: "",
      SearchResult: "",
      total_results: "",
      relation: [],
      options: [],
      tableData: [
        // { "is_hoax": 0, "author": "-", "content": "Bola.net - Ketua Umum (Ketum) PSSI, Mochamad Iriawan atau yang akrab disapa Iwan Bule memastikan, sponsor untuk Liga 1 2022/2023 tidak akan mengalami perubahan. Artinya, kompetisi kasta tertinggi sepak bola di Tanah Air itu masih disponsori oleh Bank Rakyat Indonesia (BRI). \"BRI masih akan tetap menjadi sponsor. Ini karena yang lain sedang merangkak akibat terkena badai COVID-19,\" ujar Iwan Bule, di Wisma Kemenpora, Senayan, Jakarta Pusat, Selasa (19/7). \"Tapi itu juga tergantung nantinya, ke depan kalau ada sponsor lagi mungkin kami akan sandingkan,\" katanya menambahkan. Mantan Kapolda Metro Jaya ini pun memberikan apresiasi kepada BRI. Bank milik BUMN itu sudah menjadi sponsor Liga 1 sejak musim kemarin. \"Alhamdulillah makasih karena masih setia menjadi sponsor,\" ucapnya. Baca halaman berikutnya ya Bolaneters.", "image": "https://cdns.klimg.com/bola.net/library/upload/21/2021/09/logo-bri-liga-1-2021_a1df022.jpg", "published_at": "Tue, 19 Jul 2022 07:00:00 GMT", "source": "news.google.com", "title": "Iwan Bule: BRI Masih Jadi Sponsor Liga 1", "url": "https://www.bola.net/indonesia/iwan-bule-bri-masih-jadi-sponsor-liga-1-7bde76.html" },
        // { "is_hoax": 0, "author": "Detiktv", "content": "Ketua Umum PSSI Mochamad Iriawan merangkul Shin Tae-yong seusai Timnas Indonesia U-19 tersingkir di Piala AFF U-19 2022. Ia berterima kasih kepada upaya gigih skuad Garuda Nusantara. ADVERTISEMENT SCROLL TO RESUME CONTENT", "image": "https://akcdn.detik.net.id/api/wm/2022/07/10/shin-tae-yong-mochamad-iriawan_169.jpeg?wid=54&w=650&v=1&t=jpeg", "published_at": "Mon, 11 Jul 2022 07:00:00 GMT", "source": "news.google.com", "title": "Momen Iwan Bule Peluk Shin-Tae-yong Usai Timnas U-19 Tersingkir", "url": "https://sport.detik.com/sepakbola/detiktv/d-6172780/momen-iwan-bule-peluk-shin-tae-yong-usai-timnas-u-19-tersingkir" },
        // { "is_hoax": 0, "author": "Eko Isdiyanto", "content": "Kabarkan Kondisi Timnas U-20 Indonesia, Iwan Bule Diserang Netizen Sabtu, 10 September 2022 | 17:26 WIB Ketua Umum PSSI, Mochamad Iriawan, saat ditemui di Stadion Si Jalak Harupat Soreang, Bandung, Jawa Barat, Minggu (28/8/2022). BOLASTYLO.COM - Ketua Umum PSSI, Mochamad Iriawan jadi target serangan netizen Tanah Air saat kabarkan kondisi timnas U-20 Indonesia yang tengah berlatih di Surabaya. Melalui akun Instagram pribadi, Mochamad Iriawan alias Iwan Bule mengunggah tulisan berisi kabar terkini timnas U-20 Indonesia yang berada di Surabaya. Timnas U-20 Indonesia tengah menjalani persiapan terakhir sebelum berlaga di Kualifikasi Piala Asia U-20 2023 di Stadion Gelora Bung Tomo, Surabaya \"Tiba di Surabaya, Tim U-20 Indonesia langsung jalani latihan taktikal.\" isi tulisan dalam sebuah foto yang diunggah Iwan Bule. Lebih lanjut, Iwan Bule juga menuliskan berapa pemain yang dibawa Shin Tae-yong ke Surabaya dan berapa yang akan dimainkan di babak kualifikasi tersebut. Baca Juga: Persija Jakarta Diseret PSSI ke Pusaran Drama Stadion JIS Kondisi para pemain menurut Iwan Bule juga sangat baik dan tidak ada yang cedera, sementara fokus latihan ada pada taktik dan organisasi permainan. \"Timnas U-20 sudah sampai di Surabaya didampingi Coach @shintaeyong7777. Sebanyak 30 pemain diterbangkan ke Surabaya, namun hanya 23 pemain yang akan tampil di lapangan,\" tulis Iwan Bule. \"Sesampainya di Surabaya, Timnas U-20 langsung menjalani latihan di lapangan Thor. Kondisi para pemain sangat baik tanpa cidera. \"Latihan juga difokuskan ke taktik dan organisasi permainan.\" imbuhnya. Baca Juga: Bek Persib Bandung Was-was, Hanya Berharap Hal Ini saat Lawan Arema FC View this post on Instagram A post shared by Mochamad Iriawan - Iwan Bule (@mochamadiriawan84) Unggahan itu ternyata mendapa respons cukup keras dari pecinta sepak bola Tanah Air, bukan soal persiapan timnas U-20 Indonesia di Surabaya. Akan tetapi banyak netizen yang menyinggung soal venue FIFA Matchday timnas Indonesia melawan Curacao yang batal digelar di Jakarta International Stadium (JIS). Sedianya akan digelar di Gelora Bandung Lautan Api (GBLA) pada 24 September 2022, Jawa Barat, dan direncanakan di Jakarta International Stadium (JIS) pada 27 September 2022. Namun untuk laga kedua, PSSI memutuskan untuk tetap menggelar pertandingan di Stadion GBLA. Baca Juga: Turun Kasta ke Liga 2, Cristian Gonzales Benar-benar Sudah Habis? Menurut mereka Stadion JIS tidak jadi digunakan lantaran diklaim tidak memenuhi standar FIFA dan biayanya mahal. Respons netizen Tanah Air cukup keras soal hal ini, bahkan hasrat politik Iwan Bule disebut-sebut sebagai alasan di balik pemilihan GBLA ketimbang JIS. Berikut beberapa komentar pedas netizen Indonesia terhadap Iwan Bule terkait masalah venue FIFA Matchday Indonesia yang batal digelar di JIS. @uutieey__: \"PSSI BUKAN ALAT POLITIK!,\" @ahmadhanif812: \"Cie yang mau jadi gubernur,\" @herry_achmad: \"Gini amat punya Ketum PSSI, Payah Sepakbola dibawa ke ranah Politik. Kami warga Jakarta dan Jakmania rindu Persija main di Jakarta...!!!!\" @aisyhafizu4n: \"Gak malu lo pak sepakbola elu campur sama politik,ngotak dunk pak,\" @irwnardi: TOLONG PAK JANGAN NGADI - NGADI BILANG JIS GA STANDAR FIFA. PSSI YANG GA STANDAR FIFA. BANYAK MAFIA NYA,\" @mfarhn_: \"PSSI APA PARPOL SIH SEBENERNYA?\" @jmali28: \"Kerja yg bener pak sekelas jis kok gak dilolosin sedangkan pembuatannya aja udah mengacu standar fifa apa standar pssi lebih tinggi daripada jis?lawak,\" @chocolotos13_: \"si PALING STANDART FIFA,\" @akbrber: \"Gak malu komen penuh hujatan terus pak?\" Baca Juga: Kabar Cederanya Ronaldo Kwateh Jadi Konsumsi Banyak Media Vietnam View this post on Instagram A post shared by BolaSport.com (@bolasportcom) Source : bolastylo.bolasport.com Penulis : Eko Isdiyanto Editor : Eko Isdiyanto", "image": "https://asset-a.grid.id/crop/0x0:0x0/700x465/photo/2022/08/28/img-20220828-wa0000jpg-20220828042254.jpg", "published_at": "Sat, 10 Sep 2022 07:00:00 GMT", "source": "news.google.com", "title": "Kabarkan Kondisi Timnas U-20 Indonesia, Iwan Bule Diserang Netizen", "url": "https://bolastylo.bolasport.com/read/173471807/kabarkan-kondisi-timnas-u-20-indonesia-iwan-bule-diserang-netizen" },
        // { "is_hoax": 0, "author": "Gilang Romadhan", "content": "Minggu, 7 Agustus 2022 | 13:13 WIB Kapten Timnas U16 Indonesia, Iqbal Gwijangge (kanan) bersama pelatih Bima Sakti. (Sumber: Antara Foto/Michael Siahaan) Penulis : Gilang Romadhan | Editor : Purwanto SLEMAN, KOMPAS.TV - Ketua Umum (Ketum) PSSI Mochamad Iriawan atau yang sering disapa Iwan Bule berniat menjadikan kapten Timnas U16 Indonesia, Iqbal Gwajingge sebagai anak angkat. Hal tersebut diungkapkan Iwan selepas pertandingan terakhir Grup A Piala AFF U16 2022 antara Indonesia vs Vietnam di Stadion Maguwoharjo, Sleman, Sabtu (6/8/2022) malam WIB. Iwan mengaku ingin mengawal karier dan membiayai hidup Iqbal sampai mendapatkan pekerjaan. \"Saya akan kawal sampai dia lulus dan mendapatkan pekerjaan,\" terang Iwan Bule, dikutip dari Antara. Baca Juga: Kabar Baik di Piala AFF U16 2022: Sukses ke Semifinal, Timnas Indonesia Diguyur Bonus Rp100 Juta Iqbal Gwajingge sendiri tampil cemerlang selama gelaran Piala AFF U16 2022. Pemain berdarah Papua kelahiran Sumedang, Jawa Barat itu selalu menjadi kepercayaan pelatih Bima Sakti. Posisinya sebagai bek tengah tidak tergantikan. Sebagai catatan, Indonesia memiliki rekor 13 gol dan baru satu kali kebobolan selama 3 pertandingan fase grup Piala AFF U16 2022. Satu-satunya gol yang masuk ke gawang Indonesia adalah penalti pemain Vietnam, Nguyen Chong. Mendengar niat baik dari Iwan Bule, Iqbal Gwajingge mengaku sangat senang. Dirinya menyambut baik niat dari sang Ketum PSSI. \"Alhamdulillah, orang tua saya juga bilang alhamdulillah,\" terang Iqbal. Baca Juga: Piala AFF U16: Timnas Indonesia Diyakini Bisa Lumat Vietnam dan Lolos Semifinal, Ini Analisisnya Terlepas dari itu, Indonesia akan menghadapi juara Grup C di babak semifinal yang diselenggarakan 10 Agustus 2022 di Stadion Maguwoharjo. Di Grup C sendiri, Malaysia, Myanmar, dan Kamboja masih memiliki peluang untuk lolos ke semifinal sebagai juara grup.", "image": "https://media-origin.kompas.tv/library/image/content_article/article_img/20220807051915.jpg", "published_at": "Sun, 07 Aug 2022 07:00:00 GMT", "source": "news.google.com", "title": "Iwan Bule Berniat Jadikan Kapten Timnas U16 Indonesia Sebagai Anak Angkat", "url": "https://archive.cob.web.id/archive/1666173988.668352/singlefile.html" }
      ],
      selected: [],
      selectAll: false,
      searchTarget: "",
      dnf: false,
      dnfp: false,
      is_spam: "",
      search: false,
      title: this.$t("news.news"),
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: this.$t("news.news"),
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: "no",
          class: "text-center",
          label: "#",
        },
        { key: "bulk", thStyle: { width: "2%" }, label: "#" },
        {
          key: "published",
          thStyle: { width: "10%" },
          label: this.$t("news.published_at"),
        },
        {
          key: "image",
          thStyle: { width: "10%" },
          label: this.$t("news.image"),
        },
        {
          key: "title",
          thStyle: { width: "30%" },
          label: this.$t("news.title"),
        },
        {
          key: "content",
          thStyle: { width: "40%" },
          label: this.$t("news.content"),
        },
        {
          key: "actions",
          class: "text-center",
          label: this.$t("news.actions"),
        },
      ],
      target: {
        tableData: [],
        totalRows: 1,
        currentPage: 1,
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        filter: null,
        filterOn: [],
        sortBy: "name",
        sortDesc: false,
        fields: [
          {
            key: "target",
            label: this.$t("news.target-profile"),
            sortable: true,
          },
          {
            key: "description",
            label: this.$t("news.description"),
            sortable: true,
          },
          { key: "category", label: this.$t("news.category"), sortable: true },
          {
            key: "actions",
            label: this.$t("table.citizen.th.action"),
            class: "text-center",
          },
        ],
      },
    };
  },
  computed: {
    rows() {
      return this.tableData.length;
    },
    rows_target() {
      return this.target.tableData.length;
    },

    criteria() {
      return this.searchTarget.trim().toLowerCase();
    },

    availableOptions() {
      const criteria = this.criteria;
      let element = [];
      try {
        for (let i = 0; i < this.relation.length; i++) {
          element.push(JSON.parse(this.relation[i]).id);
        }
      } catch (e) {
        element = [];
      }
      const options = this.options.filter(
        (opt) => element.indexOf(opt.id) === -1
      );
      this.show = false;
      if (criteria) {
        this.show = true;
        return options.filter((opt) =>
          opt.name.toLowerCase().includes(criteria)
        );
      }
      return options;
    },
    searchDesc() {
      if (this.criteria && this.availableOptions.length === 0) {
        return this.$t("wizard.form.validation.not_match1");
      }
      return "";
    },
    validFormat() {
      if (this.validformat != null) {
        if (this.validformat) {
          return "is-valid";
        } else {
          return "is-invalid";
        }
      }
    },
  },
  methods: {
    showFact(fact, conclusion, references) {
      // console.log(data);
      this.show_fact = fact;
      this.show_conclusion = conclusion;
      this.show_references = references;
      this.$bvModal.show("modal-show-fact");
    },

     getTargetProfile() {
      if (this.id_target != "" && this.id_target != null) {
        TargetService.getDetailTarget(this.id_target)
          .then((response) => {
            let data = {
              title: response.data.data.title,
              id: response.data.data.id_target,
            };
            this.target_data = data;
          })
          .catch((err) => {
            console.log("err ", err);
          });
      }
    },

    select() {
      // console.log('selected');
      this.selected = [];
      if (!this.selectAll) {
        for (let i in this.tableData) {
          this.selected.push(this.tableData[i]);
        }
      }
    },

    onFilteredTarget(filteredItems) {
      this.target.totalRows = filteredItems.length;
      this.target.currentPage = 1;
    },

    author(data) {
      return data[0] ?? "-";
    },

    listProfile() {
      TargetService.getTargetBy()
        .then((response) => {
          response.data.data.forEach((element) => {
            const data = {
              id_target: element.id_target,
              title: element.title,
              image_project: element.image_project,
              description: element.description,
              category: element.category.category_name,
              updated_at: element.updated_at,
            };
            this.target.tableData.push(data);
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },

    cekHoaxs(value) {
      this.loading_hoax = true;
      this.loading_hoax_url = value.url;
      let data = {
        source_link: value.url,
      };
      // console.log(data);
      NewsService.cekHoax(data)
        .then((response) => {
          // console.log('cekhoax', response.data.data);
          if (response.data.data[0]) {
            //    console.log('ada');
            let data = {
              author: value.author,
              content: value.content,
              image: value.image,
              published_at: value.published_at,
              source: value.source,
              title: value.title,
              url: value.url,
              is_hoax: response.data.data[0].status,
            };
            let index = this.tableData.findIndex(
              (element) => element["url"] == value.url
            );
            this.tableData.splice(index, 1);
            let tableDataNew = this.tableData;
            this.tableData = [];
            this.tableData.push(data);
            // console.log(tableDataNew);
            tableDataNew.forEach((val) => {
              const new_data = {
                author: val.author,
                content: val.content,
                image: val.image,
                published_at: val.published_at,
                source: val.source,
                title: val.title,
                url: val.url,
                is_hoax: val.is_hoax,
              };
              this.tableData.push(new_data);
            });
          } else {
            //    console.log('unknow');
            let data = {
              author: value.author,
              content: value.content,
              image: value.image,
              published_at: value.published_at,
              source: value.source,
              title: value.title,
              url: value.url,
              is_hoax: 3,
            };
            let index = this.tableData.findIndex(
              (element) => element["url"] == value.url
            );
            this.tableData.splice(index, 1);
            let tableDataNew = this.tableData;
            this.tableData = [];
            this.tableData.push(data);
            // console.log(tableDataNew);
            tableDataNew.forEach((val) => {
              const new_data = {
                author: val.author,
                content: val.content,
                image: val.image,
                published_at: val.published_at,
                source: val.source,
                title: val.title,
                url: val.url,
                is_hoax: val.is_hoax,
              };
              this.tableData.push(new_data);
            });
          }
          this.loading_hoax = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading_hoax = false;
        });
    },

    getNewsHoaxs() {
      let data = {
        limit: 12,
      };
      NewsService.getNewsHoax(data)
        .then((response) => {
          // console.log('data', response.data.data);
          response.data.data.forEach((val) => {
            let data = {
              id: val.id,
              authors: val.authors,
              status: val.status,
              classification: val.classification,
              title: val.title,
              fact: val.fact,
              references: val.references,
              source_issue: val.source_issue,
              source_link: val.source_link,
              picture1: val.picture1,
              picture2: val.picture2,
              tanggal: val.tanggal,
              tags: val.tags,
              conclusion: val.conclusion,
            };
            this.anti_hoax.push(data);
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },

    searchnews() {
        this.error = "";
        this.loading = true;
        this.search = true;
        this.tableData = [];
        NewsService.SearchnewsInfo(this.searchKey.trim())
            .then((response) => {
                console.log("news search ", response.data.output);
                response.data.output.forEach((val, idx) => {
                    let data = {
                        no: idx + 1,
                        author: val.author ? val.author.join(", ") : "-", // Handle array or undefined
                        content: val.content || "No content available", // Handle empty content
                        image: val.image || "https://via.placeholder.com/150", // Fallback image
                        published_at: val.published_at || "Unknown date", // Handle missing date
                        source: val.source || "Unknown source", // Handle missing source
                        title: val.title || "No title available", // Handle missing title
                        url: val.url || "#", // Handle missing URL
                        is_hoax: 0, // Default value
                    };
                    this.tableData.push(data);
                });
                this.search = true;
                this.loading = false;
            })
            .catch((err) => {
                console.log(err);
                this.loading = false;
                if (err.response?.status === 500) {
                    this.error = "Internal server Error";
                } else if (err.response?.status === 404) {
                    this.error = "Server Not Found";
                } else if (err.response?.status === 422) {
                    this.error = "Unprocessable Content: Invalid input format.";
                } else {
                    this.error = "An unexpected error occurred.";
                }
            });
    },

    saveNews(id_target) {
      Swal.showLoading();
      var data = {
        id_target: id_target,
        news: this.selected,
      };
      NewsService.SaveNews(data)
        .then((response) => {
          this.$bvModal.hide("modal-add-to-project");
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
          this.clearData();
          // console.log(response);
          this.$router.push({
            name: "project-overview",
            params: { id: id_target },
          });
        })
        .catch((err) => {
          Swal.fire({
            position: "center",
            icon: "error",
            title: err,
            showConfirmButton: false,
            timer: 1500,
          });
          this.clearData();
          console.log(err);
          this.loading = false;
        });
    },

    bulkAction() {
      Swal.fire({
        title: this.$t("button.delete.modal.confirmText[0]"),
        text: this.$t("button.delete.modal.confirmText[1]"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: this.$t("button.cancel.text"),
        confirmButtonText: this.$t("button.delete.text"),
      }).then((result) => {
        if (result.isConfirmed) {
          var data = this.selected;
          NewsService.newsBulkNewsInfo(data)
            .then((response) => {
              this.selected = [];
              this.getNewsInfo();
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: this.$t("alert.alert-delete-web"),
                showConfirmButton: false,
                timer: 1500,
              });
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },

    clearData() {
      this.tableData = [];
      this.searchKey = "";
      this.selected = [];
      this.search = false;
    },

    onOptionClick(option) {
      this.relation.push({
        name: option.name,
        id: option.id,
        image: option.image,
      });
      this.show = false;
      this.search = "";
    },

    formatDate(value) {
      return moment(value).format("YYYY-MM-DD hh:mm");
    },
  },
  beforeMount() {
    this.listProfile();
  },
  mounted() {
    this.totalRows = this.items.length;
    // this.getNewsInfo();
    this.getTargetProfile();
    this.getNewsHoaxs();
    this.availableOptions;
  },
};
</script>

<style scoped>
.image{
  height: 250px;
}
.loading {
  padding-top: 20%;
  padding-bottom: 20%;
}
</style>

